import { SNOWPLOW_ENVIRONMENT } from "@disco/disco_core";
import GET from "./utils/GET";

export const CURR_PREVIEW_TYPE = GET("previewType") || false;
export const CURR_PREVIEW_ID = GET("previewID") || null;
export const ENV = GET("environment") || "production";
export const ACTIVE_SNOWPLOW_ENV =
	ENV === "development" || ENV === "staging" || ENV === "qa"
		? SNOWPLOW_ENVIRONMENT.DEVELOPMENT
		: SNOWPLOW_ENVIRONMENT.PRODUCTION;

export const PUBLISHER = GET("publisher");
export const MONITOR_PERFORMANCE = GET("monitorPerformance") === "true";

export const BUCKET_NAME = process.env.REACT_APP_BUCKET || "coopcommerce";

export const CLOUD_FRONT_URL =
	process.env.REACT_APP_CLOUDFRONT_DOMAIN ||
	"https://d13m3pghy2f9o2.cloudfront.net";

const ENVS = {
	production: { url: "https://consumer.disconetwork.com" },
	staging: { url: "https://consumer.disconetwork-staging.com" },
	development: { url: "http://localhost:6543" },
	qa: { url: "https://consumer.disconetwork-dev.com" },
};

export const GET_BASE_URL = ENVS[ENV]?.url
	? ENVS[ENV].url
	: ENVS.production.url;

const URL_FACTORY = (path = "") =>
	!GET_BASE_URL ? "" : `${GET_BASE_URL}${path}`;

// RENDERABLE CONTENT URLS
// LEGACY URL for the widget
// export const FETCH_WIDGET_URL = URL_FACTORY(`/core/push/${PUBLISHER}/`);
export const FETCH_WIDGET_URL = URL_FACTORY(`/core/discofeed/${PUBLISHER}/`);
export const FETCH_LEAD_GEN_URL = URL_FACTORY(
	`/lead_gen/generate_lead/${PUBLISHER}/`
);
export const FETCH_SELF_WIDGET_URL = URL_FACTORY(`/core/self/${PUBLISHER}/`);
export const FETCH_ALL_SURFACES_URL = URL_FACTORY(
	`/core/modules/${PUBLISHER}/`
);

export const FETCH_MODULE_PREVIEW = URL_FACTORY(
	`/core/module_preview/${PUBLISHER}/`
);
export const FETCH_MODULES_PREVIEW = URL_FACTORY(
	`/core/modules_preview/${PUBLISHER}/`
);

export const FETCH_USER_ID_URL = () => URL_FACTORY(`/identify/user/`);

// ADD-ON URLS
export const FETCH_PRODUCT_INFO_URL = URL_FACTORY(`/core/product_details/`);

// FUNCTIONAL URLS
export const INTERMEDIATE_SURVEY_RESPONSE_URL = URL_FACTORY(
	`/core/survey_response_follow_up/${PUBLISHER}/`
);

export const SAVE_SURVEY_RESPONSE_URL = URL_FACTORY(
	`/core/survey_response/${PUBLISHER}/`
);
export const REWARDS_OPT_IN_URL = URL_FACTORY(
	`/core/rewards_email/${PUBLISHER}/`
);
export const EMAIL_OPT_IN_URL = URL_FACTORY(`/core/disco_feed_email_opt_in/`);
export const MINIMAL_OFFER_INCENTIVE_URL = URL_FACTORY(
	`/core/disco_feed_minimal_offer_incentives/`
);
export const LEAD_GEN_REGISTER_URL = URL_FACTORY(`/lead_gen/register_lead/`);

export const FETCH_CODE_URL = URL_FACTORY("/core/generate_discount_code/");

export const UPDATE_FAV_BRANDS_URL = URL_FACTORY(
	`/core/widget_user_brand_favorite/`
);

export const SURFACE_TYPES = {
	SURVEY: "survey",
	CUSTOM_POST: "custom_post",
	REWARD: "rewards",
};

export const SURFACE_DATA_KEY = {
	[SURFACE_TYPES.SURVEY]: "survey_question",
	[SURFACE_TYPES.REWARD]: "rewards",
	[SURFACE_TYPES.CUSTOM_POST]: "custom_post",
};

// ENSURE THE FOLLOWING ARE IN SYNC WITH THE SCRIPT AT ALL TIME
export const MODES = {
	INLINE: 0,
	FULLSCREEN: 1,
	FULLSCREEN_COLLAPSED: 2,
	MODAL: 3,
};
export const WIDGET_TYPE = {
	DISCOFEED: "DISCOFEED",
	LEAD_GEN: "LEAD_GEN",
	ESSENTIAL: "ESSENTIAL",
	ENGAGE: "ENGAGE",
};

export const WIDGET_VERSION = {
	[WIDGET_TYPE.ESSENTIAL]: {
		0.1: 0.1,
		0.2: 0.2,
		0.3: 0.3,
		PRODUCTION: function () {
			return this["0.1"];
		},
	},
	[WIDGET_TYPE.ENGAGE]: {
		0.1: 0.1,
		PRODUCTION: function () {
			return this["0.1"];
		},
	},
	[WIDGET_TYPE.DISCOFEED]: {
		2.0: 2.0,
		2.1: 2.1,
		PRODUCTION: function () {
			return this["2.1"];
		},
	},
	[WIDGET_TYPE.LEAD_GEN]: {
		0.1: 0.1,
		0.2: 0.2,
		0.3: 0.3,
		0.4: 0.4,
		0.5: 0.5,
		0.51: 0.51,
		0.55: 0.55,
		0.6: 0.6,
		0.65: 0.65,
		0.7: 0.7,
		0.75: 0.75,
		1.0: 1.0,
		PRODUCTION: function () {
			return this["0.55"];
		},
	},
};
export const EXPERIMENT = {
	EMAIL_OPT_IN_HEADER: "EMAIL_OPT_IN_HEADER",
	BRAND_GENERATED_INLINE_OFFERS: "BRAND_GENERATED_INLINE_OFFERS",
	FEED_INCREASE_IMPRESSIONS: "FEED_INCREASE_IMPRESSIONS",
};
// -------------------------------------------------------------------

export const VIEWS = {
	SURFACE: "SURFACE",
	OVERLAY: "OVERLAY",
	WIDGET: "WIDGET",
	ALL: "ALL",
};

export const PREVIEW_TYPE = {
	LEAD_GEN: "LEAD_GEN",
	CROSS_SELL: "CROSS_SELL",
	CROSS_SELL_PRODUCTS: "CROSS_SELL_PRODUCTS",
	UPSELL: "UPSELL",
	SURVEY: "SURVEY",
	ALL_SURVEY: "ALL_SURVEY",
};
export const PREVIEW_TYPE_CONFIG = {
	// Widget based
	[PREVIEW_TYPE.LEAD_GEN]: {
		view: VIEWS.WIDGET,
		url: FETCH_LEAD_GEN_URL,
		remoteData: {
			cross_sell: true,
			email: "test@disconetwork.com",
		},
	},
	[PREVIEW_TYPE.CROSS_SELL]: {
		view: VIEWS.WIDGET,
		url: FETCH_WIDGET_URL,
		remoteData: {
			cross_sell: true,
		},
	},
	[PREVIEW_TYPE.CROSS_SELL_PRODUCTS]: {
		view: VIEWS.WIDGET,
		url: FETCH_WIDGET_URL,
		remoteData: {
			cross_sell_products: true,
		},
	},

	[PREVIEW_TYPE.UPSELL]: {
		view: VIEWS.WIDGET,
		url: FETCH_WIDGET_URL,
		remoteData: {
			upsells: true,
		},
	},

	// Single Module based
	[PREVIEW_TYPE.SURVEY]: {
		view: VIEWS.SURFACE,
		url: FETCH_MODULE_PREVIEW,
		remoteData: {
			module_type: "survey",
			live: true,
		},
	},

	// Complete Module based
	[PREVIEW_TYPE.ALL_SURVEY]: {
		view: VIEWS.OVERLAY,
		url: FETCH_MODULES_PREVIEW,
		remoteData: {
			module_type: "survey",
			live: true,
		},
	},
};

export const EXTENSION_PREVIEW_SKIP_BTN_CLASS = "extension-preview-skip-btn";
export const EXTENSION_PREVIEW_SKIP_BTN_CLASS_FACTORY = () =>
	`${EXTENSION_PREVIEW_SKIP_BTN_CLASS}`;

export const DEFAULT_SHOP_IMG =
	"https://coopcommerce.s3-us-west-1.amazonaws.com/user_new.png";

export const MAX_PRODUCTS_PER_BRAND = 5;
export const LARGE_TILE_THRESHOLD = 5;
export const LARGE_TILE_PRODUCTS = 3;

// export const CONSUMER_REDIRECT_URL = ({
// 	first_name = false,
// 	email = false,
// 	publisher = false,
// 	user,
// 	widgetVersion = WIDGET_VERSION[2.0],
// } = {}) =>
// 	`https://www.shopdisco.com/?utm_source=DiscoFeed_${widgetVersion}&utm_medium=web&utm_campaign=${
// 		publisher || "web"
// 	}${email ? `&email=${email}` : ""}${
// 		publisher ? `&publisher_id=${publisher}` : ""
// 	}${first_name ? `&first_name=${first_name}` : ""}${user?.id ? `&dancer=${user.id}` : ""}`;

export const CONSUMER_REDIRECT_URL = ({ utmMedium = "discofeed" } = {}) =>
	`https://www.disconetwork.com/?utm_source=product&utm_medium=${utmMedium}`;
// `https://collective.disconetwork.com/?utm_source=DiscoFeed_${widgetVersion}&utm_medium=web&utm_campaign=${
// 	publisher || "web"
// }${publisher ? `&publisher_id=${publisher}` : ""}${
// 	user?.id ? `&dancer=${user.id}` : ""
// }`;

export const COLLECTIVE_URL = "https://thecoopcollective.com/";

export const UTM_PARAMS = [
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_content",
];

export const DUMMY_TEXT = `
		Lorem ipsum dolor sit amet consectetur, adipisicing elit. Id
		assumenda voluptates in est architecto, modi, eius reiciendis
		inventore asperiores dicta, enim sint tenetur facilis mollitia!
		Facere modi minima fugiat voluptate.
	`;

export const GLOBE_VIDEO_URL =
	"https://coopcommerce.s3.us-west-1.amazonaws.com/cash/globe-small.mp4";

export const DEFAULT_BANNER_IMG =
	"https://coopcommerce.s3-us-west-1.amazonaws.com/default/banner.png";

export const DEFAULT_BANNER_IMG_2 =
	"https://coopcommerce.s3-us-west-1.amazonaws.com/banner_new.jpg";

export const PRIVACY_POLICY_URL = "https://www.disconetwork.com/privacy-policy";
export const DISCO_COLLECTIVE_URL = "https://collective.disconetwork.com/";

export const OFFER_TYPE = {
	PROMO_CODE: "promo_code",
	NO_PROMO_CODE: "no_promo_code",
};
